import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {SummernoteComponent} from './summernote.component';


export class SummernoteModule{

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations:[
        SummernoteComponent
    ],
    exports:[
        SummernoteComponent
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
